import { observable, runInAction } from 'mobx';

const meetingRecordingActive = observable.box(false);
const meetingPostProcessingActive = observable.box(false);

export function setMeetingRecordingActive(active: boolean): void {
  runInAction(() => meetingRecordingActive.set(active));
}

export function isMeetingRecordingActive(): boolean {
  return meetingRecordingActive.get();
}

export function setMeetingPostProcessingActive(active: boolean): void {
  runInAction(() => meetingPostProcessingActive.set(active));
}

export function isMeetingPostProcessingActive(): boolean {
  return meetingPostProcessingActive.get();
}
